import { QueryClient } from '@tanstack/react-query';

// Is this a client error we should NOT retry? (bad request / not found / not ready / conflict)
const isClientError = (error) => {
  const status = error?.status;
  return typeof status === 'number' && status >= 400 && status < 500;
};

/**
 * Shared QueryClient. Sensible caching defaults plus a retry policy that backs off on transient
 * failures but never hammers the server on deterministic 4xx responses.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // treat data as fresh for 30s → fewer refetches, snappier nav
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isClientError(error)) return false; // 400/404/409 won't change on retry
        return failureCount < 2; // otherwise up to 2 retries (network / 5xx)
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      retry: (failureCount, error) => {
        if (isClientError(error)) return false;
        return failureCount < 1;
      },
    },
  },
});

export default queryClient;
